import { AxiosPromise } from 'axios';
import { http } from 'services';

export const Challange = (): AxiosPromise<{ data: { challange: string } }> => {
  return http.request.get<{ data: { challange: string } }>(`/oauth/eds/challenge`);
};
